__turbopack_context__.v({
  "membership-dues-table": "OjXDhW_membership-dues-table",
  "wrapper": "OjXDhW_wrapper",
  "wrapper__description": "OjXDhW_wrapper__description",
  "wrapper__label": "OjXDhW_wrapper__label",
});
